export default {"src":"/uk/_next/static/media/spot-expert.29460cd6.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};